import * as React from 'react';

import { Subtitle } from 'components/ScreenerResults/ScreenerChart/components/shared';

import { ChartDataPoint } from '../../types';
import { HorizontalBarChart } from '../HorizontalBarChart';

interface MatrixChartProps {
  answers: ScreenerResponseAnswerValue<'matrix'>[];
  total?: number;
}

export const MatrixChart: React.FC<React.PropsWithChildren<MatrixChartProps>> = ({ total, answers }) => {
  // Group answers by question (key) and count response values
  const groupedData = React.useMemo(() => {
    const groups: Record<string, Record<string, number>> = {};

    answers.forEach((answer) => {
      if (answer && typeof answer === 'object') {
        Object.entries(answer).forEach(([question, response]) => {
          if (!groups[question]) {
            groups[question] = {};
          }
          if (!groups[question][response]) {
            groups[question][response] = 0;
          }
          groups[question][response]++;
        });
      }
    });

    return groups;
  }, [answers]);

  if (total === 0 || !total) {
    return null;
  }

  return (
    <>
      <Subtitle type='Matrix' total={total} />
      <div>
        {Object.entries(groupedData).map(([question, responses]) => {
          // Convert responses to ChartDataPoint format
          const chartData: ChartDataPoint[] = Object.entries(responses)
            .sort(([, a], [, b]) => b - a) // Sort by count descending
            .map(([response, count]) => ({
              x: response,
              y: count
            }));

          return (
            <div key={question} className='mb-6'>
              <h4 className='mb-6 text-sm font-bold'>{question}</h4>
              <HorizontalBarChart data={chartData} total={total} />
            </div>
          );
        })}
      </div>
    </>
  );
};
